var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "attempt-box",
      style: {
        border: `2px solid ${
          _vm.selected ? _vm.$themeTokens.text : _vm.$themeTokens.textDisabled
        }`,
        cursor: _vm.selected ? "auto" : "pointer",
      },
      attrs: { "data-testid": "attemptBox" },
    },
    [
      _vm.isAnswer
        ? [
            _vm.interaction.correct
              ? _c("KIcon", {
                  staticClass: "svg-item",
                  style: [
                    _vm.svgItemBorder,
                    { fill: _vm.$themeTokens.correct },
                  ],
                  attrs: {
                    icon: "correct",
                    "data-testid": "correctAnswerIcon",
                  },
                })
              : _vm._e(),
            !_vm.interaction.correct
              ? _c("KIcon", {
                  staticClass: "svg-item",
                  style: [
                    _vm.svgItemBorder,
                    { fill: _vm.$themeTokens.incorrect },
                  ],
                  attrs: {
                    icon: "incorrect",
                    "data-testid": "incorrectAnswerIcon",
                  },
                })
              : _vm._e(),
          ]
        : _vm.isHint
        ? _c("KIcon", {
            staticClass: "svg-item",
            style: [_vm.svgItemBorder, { fill: _vm.$themeTokens.annotation }],
            attrs: { icon: "hint", "data-testid": "hintIcon" },
          })
        : _vm.isError
        ? _c("KIcon", {
            staticClass: "svg-item",
            style: [_vm.svgItemBorder, { fill: _vm.$themeTokens.annotation }],
            attrs: { icon: "helpNeeded", "data-testid": "helpNeededIcon" },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }